(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('[data-noir-config]').textContent);
    const money = value => new Intl.NumberFormat('pt-BR', {style:'currency',currency:config.currency || 'BRL'}).format(value / 100);
    const hero = root.querySelector('.noir__image');
    const zoom = root.querySelector('.noir__zoom-image');
    root.querySelectorAll('[data-noir-image]').forEach(button => {
      button.addEventListener('click', () => {
        hero.removeAttribute('srcset');
        hero.src = button.dataset.noirImage;
        hero.alt = button.getAttribute('aria-label');
        zoom.removeAttribute('srcset');
        zoom.src = button.dataset.noirImage;
        root.querySelectorAll('[data-noir-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    const show = dialog => { if (!dialog.open) dialog.showModal(); };
    root.querySelector('[data-noir-zoom]').addEventListener('click', () => show(root.querySelector('.noir__zoom-dialog')));
    root.querySelectorAll('[data-noir-open]').forEach(button => button.addEventListener('click', () => show(document.getElementById(button.dataset.noirOpen))));
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelector('[data-noir-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
    });
    root.querySelectorAll('.noir__radio').forEach(radio => radio.addEventListener('change', () => {
      const cents = Number(radio.dataset.price);
      root.querySelector('[data-noir-price]').textContent = money(cents);
      root.querySelector('[data-noir-installment]').textContent = money(Math.round(cents * config.installmentFactor / 12));
      const buy = root.querySelector('[data-noir-buy]');
      const available = radio.dataset.available === 'true';
      buy.disabled = !available;
      buy.textContent = available ? buy.dataset.availableLabel : buy.dataset.unavailableLabel;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      history.replaceState({}, '', url);
    }));
    if (root.dataset.productId === '15412309033197') {
      const legacyVariants = {
        '50108915974381': '67639931109613',
        '50108916007149': '67639931142381',
        '50108916039917': '67639931175149',
        '50108916072685': '67639931207917'
      };
      const requested = new URL(window.location.href).searchParams.get('variant');
      const mapped = legacyVariants[requested];
      const radio = mapped && root.querySelector('.noir__radio[value="' + mapped + '"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }
  }
  document.querySelectorAll('[data-noir]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-noir]').forEach(init));
})();
